import { createContext } from 'react';


export const UserRoleContext = createContext(null);
export const ProductIdContext = createContext(null);
export const BrandContext = createContext(null);
